import type { GridPos, GridSnapshot } from "@reagent/sim";
import type { PendingMove } from "../../app/gameStore";

/**
 * Whether a moved machine could land on `tile`: on the board, unoccupied, not
 * contaminated and not locked by a hazard card. The engine stays the arbiter —
 * this only decides the ghost's tint, so a refused drop is foreseen rather
 * than discovered.
 */
export function moveTargetValid(snapshot: GridSnapshot, tile: GridPos): boolean {
  if (tile.x < 0 || tile.y < 0 || tile.x >= snapshot.cols || tile.y >= snapshot.rows) return false;
  const same = (p: GridPos) => p.x === tile.x && p.y === tile.y;
  if (snapshot.nodes.some((n) => same(n.pos))) return false;
  if (snapshot.contaminatedTiles.some((c) => same(c.pos))) return false;
  if (snapshot.deckPenalties.lockedTiles.some(same)) return false;
  return true;
}

/** The pipes a pending node move will sell back, or none for any other state. */
export function soldBackEdges(
  snapshot: GridSnapshot,
  pending: PendingMove | null,
): GridSnapshot["edges"] {
  if (pending?.kind !== "node") return [];
  const ids = new Set(pending.soldBackEdgeIds);
  return snapshot.edges.filter((e) => ids.has(e.id));
}
